import React from "react";
import { useHistory } from "react-router-dom";

import AcceptIcon from "assets/icons/accept.svg";

import Button from "components/Button";
import * as S from "./styles";

export const Feedback = () => {
  const history = useHistory();

  return (
    <S.Container>
      <S.ImageWrapper>
        <S.Image src={AcceptIcon} />
      </S.ImageWrapper>

      <Button
        icon="Home"
        type="button"
        onClick={() => {
          history.push("/");
        }}
      >
        Voltar a página inicial
      </Button>
    </S.Container>
  );
};
